import { useEffect, useState } from 'react';
import styles from './BookingManagementBookingTable.module.css';
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { FaCirclePlus } from "react-icons/fa6";
import { EmployBookingList } from 'modules/booking';
import EmployBookingListTable from '../bookingListTable/employBookingListTable';
import EmployBookingPopup from 'pages/employ/bookinkPooup/BookingPopup';
import { getallBookingsList } from 'services/booking/get-all-bookings-list';
import EmployUnregesteredBookingPopup from '../bookinkPooup/bookingUnregisteredPopup';
import { FaHistory } from 'react-icons/fa';

type SortConfig = {
    key: 'parentName' | 'age' | 'request_date' | 'date' | 'status' | null;
    direction: 'asc' | 'desc';
};

export default function EmployBookingManagementBookingTable() {
    const [bookingsData, setBookingsData] = useState<EmployBookingList[]>([]);
    const [sortConfig, setSortConfig] = useState<SortConfig>({ key: null, direction: 'asc' });
    const [isPopupBookingOpen, setIsPopupBookingOpen] = useState(false);
    const [isPopupUnregesterBookingOpen, setIsPopupUnregesterBookingOpen] = useState(false);
    const [showFutureBooking, setShowFutureBooking] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState(false);

    const handleOpenBookingPopup = () => setIsPopupBookingOpen(true);

    const handleCloseBookingPopup = () => {
        setIsPopupBookingOpen(false);
        fetchData();
    }
    const handleCloseUnregesterBookingPopup = () => {
        setIsPopupUnregesterBookingOpen(false);
        fetchData();
    }
    const handelOnchange = () => {
        if (isPopupBookingOpen) {
            setIsPopupBookingOpen(false);
            setIsPopupUnregesterBookingOpen(true);
        } else if (isPopupUnregesterBookingOpen) {
            setIsPopupUnregesterBookingOpen(false);
            setIsPopupBookingOpen(true);
        }
    };

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const rawBookingData = await getallBookingsList(['confirmed', 'pending', 'rejected'], showFutureBooking);

            if (rawBookingData.Kids_bookings_data) {
                const bookingData = rawBookingData.Kids_bookings_data.map((booking: any) => {
                    let finalStatus = booking.status;
                    if (booking.recurrence === 'serial') {
                        const recurrenceStatuses = [
                            booking.recurrence_date_0_status,
                            booking.recurrence_date_1_status,
                            booking.recurrence_date_2_status,
                            booking.recurrence_date_3_status
                        ];

                        if (booking.status === 'pending') {
                            finalStatus = 'offen';
                        }

                        else if (booking.status == "confirmed") {
                            finalStatus = 'bestätigt';
                            const hasRejected = recurrenceStatuses.includes('rejected');
                            const hasCancelled = recurrenceStatuses.includes('cancelledConfirmed') || recurrenceStatuses.includes('cancelledPending');
                            if (hasRejected) {
                                finalStatus = 'bestätigt (teilweise abgelehnt)';
                            }
                            else if (hasCancelled) {
                                finalStatus = 'bestätigt (teilweise storniert)';
                            }
                        }
                        else if (booking.status === 'rejected') {
                            finalStatus = 'abgelehnt';
                        }

                    } else if (booking.recurrence === 'onetime') {
                        finalStatus = booking.status === 'pending' ? 'offen' : booking.status === 'confirmed' ? 'bestätigt' : 'abgelehnt';
                    }
                    return {
                        ...booking,
                        kidName: `${booking.kid_first_name} ${booking.kid_last_name}`,
                        parentName: `${booking.profile_first_name} ${booking.profile_last_name}`,
                        status: finalStatus,
                        block: `${booking.start_time.substring(0, 5) || ''} - ${booking.end_time.substring(0, 5) || ''}`,
                        request_date: booking.request_date?.substring(0, 10) || ''
                    };
                });
                bookingData.sort((a: any, b: any) => {
                    if (a.status === 'offen' && b.status !== 'offen') return -1;
                    if (a.status !== 'offen' && b.status === 'offen') return 1;

                    return new Date(b.date).getTime() - new Date(a.date).getTime();
                });
                setBookingsData(bookingData);
            }

        } catch (error) {
            console.error("Fehler beim Abrufen der daten:", error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        fetchData();
    }, [showFutureBooking]);


    const sortedBookings = [...bookingsData].sort((a, b) => {
        if (sortConfig.key) {
            let aValue = a[sortConfig.key];
            let bValue = b[sortConfig.key];
            if (aValue === undefined) return 1;
            if (bValue === undefined) return -1;

            if (
                (sortConfig.key === 'request_date' || sortConfig.key === 'date') &&
                typeof aValue === 'string' &&
                typeof bValue === 'string'
            ) {
                const aDate = new Date(aValue.split('.').reverse().join('-'));
                const bDate = new Date(bValue.split('.').reverse().join('-'));

                if (aDate < bDate) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aDate > bDate) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
            } else {
                if (aValue < bValue) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
            }
        }
        return 0;
    });

    const handleSort = (key: 'parentName' | 'age' | 'request_date' | 'date' | 'status') => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };


    return (
        <div className={styles.tableContainer}>
            <div className={styles.tableHeader}>
                <h2>Buchungsanfragen</h2>

                <button className={`${commonStyles.commonButton} ${styles.bookingButton}`} onClick={handleOpenBookingPopup}>
                    <p>Neue Buchung</p>
                    <FaCirclePlus className={commonStyles.commonButtonIcon} />
                </button>
            </div>
            <EmployBookingListTable bookings={sortedBookings} onSort={handleSort} sortConfig={sortConfig} onback={handleCloseBookingPopup} isCancel={false} />

            {showFutureBooking &&
                <button className={`${commonStyles.commonButton} ${styles.cancelButton} ${styles.showAllButton}`}
                    onClick={() => setShowFutureBooking(false)}
                >
                    {isLoading ? (
                        <div className={commonStyles.spinner}></div>
                    ) : (
                        "Vorherige Buchungen anzeigen"
                    )}

                    <FaHistory className={commonStyles.commonButtonIcon} />
                </button>}
            <EmployBookingPopup isOpen={isPopupBookingOpen} onClose={handleCloseBookingPopup} onChange={handelOnchange} />
            <EmployUnregesteredBookingPopup isOpen={isPopupUnregesterBookingOpen} onClose={handleCloseUnregesterBookingPopup} onChange={handelOnchange} />
        </div>
    );
}
